import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SideMenuDrawer from './SideMenuDrawer';
import { useNavigate } from "react-router";
import { FaSearch, FaUser, FaPodcast } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from "../Redux/auth/action";
import { Link, NavLink } from "react-router-dom";
import Logo from "../Utils/title.jpg";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    boxShadow: 'none',
  },
  appBar: {
    backgroundColor: "white",
    color: "black",
    borderBottom: '1px solid #e2e2e2',
    boxShadow: 'none',
    padding: '0',
    [theme.breakpoints.down('sm')]: {
      padding: '0 10px',
    },
  },
  toolbar: {
    padding: '0 8%',
    minHeight: '40px',
    [theme.breakpoints.down('md')]: {
      padding: '0 4%',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 2%',
    },
  },
  menuButton: {
    marginRight: theme.spacing(1),
    color: '#333',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  desktopMenuButton: {
    marginRight: theme.spacing(1),
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  title: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      marginLeft: '10px',
    },
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  logo: {
    margin: '0 auto',
    cursor: 'pointer',
    maxWidth: '250px',
    padding: '8px 0',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '180px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '150px',
    },
  },
  loginButton: {
    backgroundColor: "#567B95",
    borderRadius: '3px',
    padding: '6px 12px',
    marginLeft: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#466582',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '4px 8px',
      marginLeft: theme.spacing(1),
    },
  },
  loginLink: {
    fontSize: "11px",
    color: "white",
    fontWeight: "bold",
    textDecoration: "none",
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: "10px",
    },
  },
    adminLink: {
    marginLeft: "5px",
    fontSize: "11px",
    color: "white",
    fontWeight: "bold",
    textDecoration: "none",
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: "10px",
    },
  },
  searchIcon: {
    color: '#333',
    fontSize: '16px',
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(1),
    },
  },
  userIcon: {
    fontSize: '14px',
    marginRight: '4px',
  },
  dateText: {
    fontSize: '12px',
    color: '#666',
    marginRight: '20px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  navLink: {
    fontSize: '12px',
    color: '#333',
    textDecoration: 'none',
    margin: '0 10px',
    fontWeight: '500',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  mobileSearch: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  mobileNav: {
    display: 'none',
    backgroundColor: '#f7f7f7',
    padding: '10px 0',
    borderBottom: '1px solid #e2e2e2',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    },
  },
  mobileNavLink: {
    fontSize: '12px',
    color: '#333',
    textDecoration: 'none',
    margin: '0 8px',
    fontWeight: '500',
  },
}));

export default function Navbar() {
  const classes = useStyles();
  const history = useNavigate();
  const isAuth = useSelector(state => state.auth.isAuth);
  const dispatch = useDispatch();
  const [currentDate] = useState(new Date().toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  }));

  const logout_user = () => {
    dispatch(logout());
    localStorage.clear();
    history("/login");
  };

  const AdminDashboard = () => {
    history("/admin/dashboard");
  };

  const handleHome = () => {
    history('/');
  };

  return (
    <div className={classes.root}>
      <div style={{ 
        backgroundColor: '#f7f7f7', 
        padding: '4px 8%', 
        display: 'flex', 
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '12px',
        borderBottom: '1px solid #e2e2e2'
      }}>
        <span>{currentDate}</span>
        <div>
          <a href="/news/ssd" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>S.SD</a>
          <a href="/news/East.Africa" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>East.Africa</a>
          <a href="/news/Africa" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>Africa</a>
          <a href="/news/International" style={{ color: '#333', margin: '0 10px', textDecoration: 'none' }}>International</a>
        </div>
      </div>

      <AppBar className={classes.appBar} position="static">
        <Toolbar className={classes.toolbar}>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
            <SideMenuDrawer/>
          </IconButton>
          
          <div className={classes.navLinks}>
            <NavLink to="/news/ssd" className={classes.navLink}>SSD</NavLink>
            <NavLink to="/news/world" className={classes.navLink}>World</NavLink>
            <NavLink to="/news/business" className={classes.navLink}>Business</NavLink>
            <NavLink to="/news/arts" className={classes.navLink}>Arts</NavLink>
            <NavLink to="/news/lifestyle" className={classes.navLink}>Lifestyle</NavLink>
          </div>

          <IconButton className={classes.desktopMenuButton} color="inherit">
             <NavLink to = "/search"><FaSearch/></NavLink>
          </IconButton>

          <Typography variant="h6" className={classes.title}>
            <img 
              className={classes.logo} 
              src={Logo} 
              alt="The Juba Times" 
              onClick={handleHome}
            />
          </Typography>

          <div className={classes.mobileSearch}>
            <IconButton color="inherit">
               <NavLink to = "/search"><FaSearch/></NavLink>
            </IconButton>
          </div>

          <Button className={classes.loginButton} variant="text" size="small">
            {isAuth ? (
              <>
                <span className={classes.adminLink} onClick={AdminDashboard}>
                  <FaPodcast className={classes.userIcon} /> Admin
                </span>

                <span className={classes.loginLink} onClick={logout_user}>
                  <FaUser className={classes.userIcon} /> LOGOUT
                </span>
              </>
              
            ) : (
              <Link className={classes.loginLink} to='/login'>
                <FaUser className={classes.userIcon} /> LOGIN
              </Link>
            )}
          </Button>
        </Toolbar>
      </AppBar>

      <div className={classes.mobileNav}>
        <NavLink to="/news/ssd" className={classes.mobileNavLink}>S.S.D</NavLink>
        <NavLink to="/news/world" className={classes.mobileNavLink}>World</NavLink>
        <NavLink to="/news/business" className={classes.mobileNavLink}>Business</NavLink>
        <NavLink to="/news/arts" className={classes.mobileNavLink}>Arts</NavLink>
        <NavLink to="/news/lifestyle" className={classes.mobileNavLink}>Lifestyle</NavLink>
        <NavLink to="/news/opinion" className={classes.mobileNavLink}>Opinion</NavLink>
        <NavLink to="/news/games" className={classes.mobileNavLink}>Games</NavLink>
      </div>
    </div>
  );
}